import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url.js';
import * as b from "../../bootstrap.module.css";

const ConsumerLeasingContents = ({ active }) => {
  const { articles } = useStaticQuery(graphql`
    query ConsumerLeasingContents {
      articles: allMysqlBlog(
        filter: {blogTerms: {elemMatch: {term: {eq: "menu-consumer-leasing"}}}},
        limit: 6
      ) {
        nodes {
          title
          terms_path
          term_normalized
          url
          thumbnail_canvas
        }
      }
    }
  `);

  return (<>
    {active && articles.nodes.length > 0 && (<>
      <strong>Artykuły o leasingach pozabankowych</strong>

      <div className={['top-navigation-posts', b.mt2, b.pt1].join(' ')}>
        {articles.nodes.map((article, i) => (
          <Link key={i} to={resolveUrl(article.terms_path, article.term_normalized, article.url)}>
            <img src={article.thumbnail_canvas?.replace('/fa/', '/fk/')} className="top-navigation-thumbnail" loading="lazy" alt="" />
            
            <strong>{article.title}</strong>
          </Link>
        ))}
      </div>  
    </>)}
  </>);
};

export default ConsumerLeasingContents;
